import { render, staticRenderFns } from "./PageLayoutSettings.vue?vue&type=template&id=1cd6ce63&scoped=true&"
import script from "./PageLayoutSettings.vue?vue&type=script&lang=js&"
export * from "./PageLayoutSettings.vue?vue&type=script&lang=js&"
import style0 from "./PageLayoutSettings.vue?vue&type=style&index=0&id=1cd6ce63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd6ce63",
  null
  
)

export default component.exports